import {
  BackendServerActionType,
  ButtonElementModel,
  ButtonPanelElementModel,
  CastUtility,
  DbCommonColumnName,
  DevelopEditViewScript,
  DevelopScriptServicePack,
  EditPanelElementModel,
  EditType,
  EditTypeUtility,
  InputPartsBaseModel,
  KeyUsedByItem,
  LinkElementModel,
  MessageType,
  PanelModel,
  PanelType,
  SubTicketBaseModel,
  SubTicketListPanelElementModel,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
import { MProgramUtility } from 'src/app/utility/m-program-utility';

/**
 * プログラム編集画面のスクリプト
 */
export class MProgramEdit implements DevelopEditViewScript {
  scriptName: string = 'MProgramEdit';
  panelModuls: Map<PanelType, PanelModel> = new Map<PanelType, PanelModel>();
  isSpotProgram: boolean = false;

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    this.panelModuls = panelModels;
    if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
      this.setDeleteButton(this.panelModuls);
    }
    this.hiddenRegisterButton(panelModels);
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;

    MProgramUtility.fetchProducerSelectOptions().then((producerList) => {
      MProgramUtility.setupProducerSelectBox(editPanel, service, producerList);
    });

    // 新規は事前登録のみ
    this.isSpotProgram = EditTypeUtility.getEditTypeInUrl() === EditType.New;
    if (this.isSpotProgram) {
      this.showSpotProgramInputParts(editPanel);
    }
  }
  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}
  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
  /**
   * 検索処理終了後の処理
   * @param editPanel
   * @param service
   */
  async fetchedRecord(editPanel: EditPanelElementModel, service: DevelopScriptServicePack): Promise<void> {
    //権限制御
    const canEdit = await MProgramUtility.canEditProgramByLoginUser(editPanel.commonDBValue.ticketKey);
    if (!canEdit) {
      service.moveEditTypeButtonService.hiddenEditButton();
    }
    if (!canEdit && editPanel.editType === EditType.Edit) {
      service.dialogService
        .showOkOnlyConfirmDialog(
          '現在のユーザーでは\n指定した編集モードで画面を表示することはできません。\n読み取り専用に遷移します。'
        )
        .then(() => {
          service.moveViewService.changeEditType(EditType.Readonly);
        });
    }
    editPanel.inputPartsList.forEach((inputParts) => {
      if (inputParts.id === 'IsSpotProgram') {
        this.isSpotProgram = inputParts.value === 'true';
      }
    });

    if (EditTypeUtility.getEditTypeInUrl() !== EditType.New) {
      this.setDeleteButton(this.panelModuls);
    }

    // 事前登録でない場合は、放送予定日、放送時間を表示する
    if (this.isSpotProgram) {
      // editPanel.inputPartsList.forEach((inputParts) => {
      //   if (inputParts.id === 'ScheduledOnairDate') {
      //     inputParts.isHidden = false;
      //     inputParts.required = true;
      //   }
      //   if (inputParts.id === 'ScheduledOnairTime') {
      //     inputParts.isHidden = false;
      //     inputParts.required = true;
      //   }
      // });

      this.showSpotProgramInputParts(editPanel);
    }
  }
  /**
   * ボタン押下時の処理
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id === 'subTicketAddButton') {
      const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
      const editValues = editPanel.getIdAndValueAsObject();
      this.addSubTicket(editValues['ProgramCode'], editPanel.subTicketListPanelElementModel, service);
    }

    // 保存ボタン押下
    else if (clickedButtonElement.id === 'RegisterButton') {
      this.registerMProgram(panelModels, service);
    } else if (clickedButtonElement.id === 'DeleteButton') {
      this.deleteMProgram(panelModels, service);
    }
  }

  /**
   * リンク押下時の処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}
  /**
   * 入力パーツのイベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {
    if (inputPartsModel.id === 'ScheduledOnairTime') {
      this.convertTimeFormat(inputPartsModel);

      const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
      this.inputValidateCheck(editPanel, inputPartsModel);
    }
  }

  /**
   * 登録ボタンの表示・非表示を設定する
   * @param panelModels
   */
  hiddenRegisterButton(panelModels: Map<PanelType, PanelModel>) {
    const buttonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;

    buttonPanel.leftButtons.forEach((button: ButtonElementModel) => {
      if (button.id === 'RegisterButton') {
        button.isHidden = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly;
      }
    });
  }

  /**
   * 削除ボタンを表示するときはtrueをそれ以外はfalseを返す。
   * @param panelModels
   * @returns
   */
  async isShowDeleteButton(panelModels: Map<PanelType, PanelModel>) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    if (EditTypeUtility.getEditTypeInUrl() !== EditType.Readonly) {
      return false;
    }
    if (!this.isSpotProgram) {
      return false;
    }
    const canEdit = await MProgramUtility.canEditProgramByLoginUser(editPanel.commonDBValue.ticketKey);
    return canEdit;
  }

  /**
   * 削除ボタンの表示・非表示を設定する
   * @param panelModels
   */
  setDeleteButton(panelModels: Map<PanelType, PanelModel>) {
    const getDeleteButtonElement = () => {
      const buttonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;
      const deleteButtons = buttonPanel.leftButtons.filter((button) => button.id === 'DeleteButton');
      return deleteButtons[0];
    };

    const deleteButton = getDeleteButtonElement();
    this.isShowDeleteButton(panelModels).then((result) => {
      deleteButton.isHidden = !result;
    });
  }

  showSpotProgramInputParts(editPanel: EditPanelElementModel) {
    editPanel.inputPartsList.forEach((inputParts) => {
      if (inputParts.id === 'ScheduledOnairDate') {
        inputParts.isHidden = false;
        inputParts.required = true;
      }
      if (inputParts.id === 'ScheduledOnairTime') {
        inputParts.isHidden = false;
        inputParts.required = true;
      }
      if (inputParts.id === 'ProgramCode') {
        inputParts.required = false;
      }
      if (inputParts.id === 'ProgramName') {
        inputParts.classAtLabel.push('pre-program');
      }
    });
  }

  /**
   * サブチケットを追加する
   * @param programCode
   * @param subTicketListPanel
   * @param service
   */
  addSubTicket(
    programCode: string,
    subTicketListPanel: SubTicketListPanelElementModel,
    service: DevelopScriptServicePack
  ): void {
    subTicketListPanel.addNewSubTicket();

    const addIndex = subTicketListPanel.subTicketList.length - 1;
    const addSubTicket = subTicketListPanel.subTicketList[addIndex];

    // 入力欄の値をセット
    const setValueWithColumnName = (columnName: string, value: any) => {
      const column = addSubTicket.getColumnByColumnName(columnName);
      if (!column) {
        return;
      }
      column.inputParts.setValue(value);
    };
    setValueWithColumnName('ProgramCode', programCode);
    setValueWithColumnName('ReceiptDateType', 'Onairdate');
  }
  /**
   * サブチケットのカラムを取得する
   * @param subTicket
   * @param columnName
   * @returns
   */
  getSubTicketColumnName = (subTicket: SubTicketBaseModel, columnName: string) => {
    const column = subTicket.getColumnByColumnName(columnName);
    if (!column) {
      throw new Error(`サブチケットのカラムが見つかりませんでした。columnName:${columnName}`);
    }
    return column;
  };

  /**
   * 押下されたボタンの行番号を取得する
   * @param clickedButtonElement
   * @returns
   */
  getRowIndexFromButtonId = (clickedButtonElement: ButtonElementModel) =>
    CastUtility.anyToNumber(clickedButtonElement.id.split('_')[1]);

  /**
   * MProgramを登録する
   *
   * @description
   * ### 処理の流れ
   * 1. バリデーションチェック
   * 2. 登録データを作成する
   *  - 通常の入力項目の登録データを作成
   *  - サブチケットの登録データを作成
   * 3. データ登録処理
   *
   * @remarks
   * 登録データを一部加工するため、独自の登録処理を実装
   *
   * @param panelModels
   * @param service
   */
  registerMProgram(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;

    /**
     * 登録データを作成する
     */
    const createRegisterData = () => {
      /**
       * サブチケットの登録データを作成
       * @returns
       */
      const createSubTicketRegisterData = () => {
        let subTicketRequestData: { [key in string]: any[] } = {};
        let responseSubTicketList: any[] = [];
        editPanel.subTicketListPanelElementModel.subTicketList.forEach(
          (subTicket: SubTicketBaseModel, index: number) => {
            // リクエストデータに含めて良いか判定
            if (!subTicket.canIncludeRequestData()) {
              return;
            }
            subTicket.setRowIndex(index);
            let subTicketData = subTicket.getRequestData();
            responseSubTicketList.push(subTicketData);
          }
        );

        subTicketRequestData[editPanel.subTicketListPanelElementModel.subTicketDataType] = responseSubTicketList;
        return subTicketRequestData;
      };

      const registerData = editPanel.getIdAndValueAsObject();
      let orderCount = 0;
      editPanel.subTicketListPanelElementModel.subTicketList.forEach((subTicket: SubTicketBaseModel) => {
        if (subTicket.ticketInfo.active) {
          orderCount++;
        }
      });
      registerData['OrderCount'] = orderCount;
      registerData[KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME] = createSubTicketRegisterData();

      if (this.isSpotProgram) {
        registerData['ProgramCode'] = 'SPOT';
        registerData['IsSpotProgram'] = true;
      }

      return registerData;
    };

    // チェック処理
    if (!this.ValidateAllCheck(editPanel, service)) {
      return;
    }

    // 登録データを取得
    const registerData = createRegisterData();
    const request = Object.assign(editPanel.commonDBValue.getKeyValueForEditPanel(), registerData);

    //データ登録後、詳細画面へ遷移
    const registerCallBack = (responseRecord: any) => {
      service.moveViewService.changeEditType(EditType.Readonly, {
        [DbCommonColumnName.TICKET_KEY]: responseRecord.data[DbCommonColumnName.TICKET_KEY],
      });
    };
    // データ登録処理
    service.dataTransmissionService.registerRecord(ViewType.Edit, 'MProgram', request, registerCallBack);
  }

  /**
   * 番組マスタの一覧画面に遷移する
   * @param service
   * @param editPanel
   */
  moveToConditionList(service: DevelopScriptServicePack, editPanel: EditPanelElementModel) {
    service.moveViewService.moveViewInGocooEngine(
      ViewType.ConditionList,
      editPanel.commonDBValue.ticketType,
      EditType.Readonly,
      {}
    );
  }

  /**
   * 削除ボタンを押下したときの処理
   * @param panelModels
   * @param service
   */
  deleteMProgram(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const request = {
      [DbCommonColumnName.TICKET_TYPE]: editPanel.commonDBValue.ticketType,
      [DbCommonColumnName.TICKET_KEY]: editPanel.commonDBValue.ticketKey,
    };

    const callBackAfterDelete = () => {
      service.dialogService.showOkOnlyConfirmDialog('データを削除しました。').then(() => {
        this.moveToConditionList(service, editPanel);
      });
    };
    service.dataTransmissionService.deleteRecord(
      ViewType.Edit,
      editPanel.commonDBValue.ticketType,
      request,
      callBackAfterDelete
    );
  }

  /**
   * 時刻の入力形式を整える
   * @param inputPartsModel
   */
  convertTimeFormat(inputPartsModel: InputPartsBaseModel) {
    if (new RegExp('^[0-9]{2}$').test(inputPartsModel.value)) {
      inputPartsModel.value += ':';
    } else if (new RegExp('^[0-9]:$').test(inputPartsModel.value)) {
      inputPartsModel.value = '0' + inputPartsModel.value;
    }
  }

  /**
   * 時刻の入力チェックを行う
   * @param editPanel
   * @param inputPartsModel
   */
  inputValidateCheck(editPanel: EditPanelElementModel, inputPartsModel: InputPartsBaseModel) {
    if (!!new RegExp('^[0-9]{2}:[0-9]{2,}$').test(inputPartsModel.value)) {
      this.validateTimeCheck(editPanel);
    } else {
      inputPartsModel.clearValidateClass();
    }
  }

  /**
   * 登録された時刻の入力チェックを行う。
   * @param editPanel
   * @returns
   */
  validateTimeCheck(editPanel: EditPanelElementModel) {
    const errorResult = (message: string) => {
      scheduledOnairTime.validateErr(message);
      result = false;
    };
    const scheduledOnairTime = this.getScheduledOnairTime(editPanel);

    let result = true;
    //非表示の時は入力チェックを行わない。
    if (scheduledOnairTime.isHidden) {
      return result;
    }
    //hh:mからhh:0mに変換する。
    if (new RegExp('^[0-9]{2}:[0-9]$').test(scheduledOnairTime.value)) {
      const times = scheduledOnairTime.value.split(':');
      scheduledOnairTime.value = times[0] + ':0' + times[1];
    }

    if (!new RegExp('^[0-9]{2}:[0-9]{2}$').test(scheduledOnairTime.value)) {
      errorResult('入力形式が不正です');
      return result;
    }
    if (!new RegExp('^(0[4-9]|1[0-9]|2[0-8]):[0-5][0-9]$').test(scheduledOnairTime.value)) {
      errorResult('04:00~28:59で入力してください');
      return result;
    }
    return result;
  }

  getScheduledOnairTime(editPanel: EditPanelElementModel) {
    const scheduledOnairTimes = editPanel.inputPartsList.filter((inputParts) => inputParts.id === 'ScheduledOnairTime');
    return scheduledOnairTimes[0];
  }
  /**
   * 入力項目の全体的なチェック処理
   * @param editPanel
   * @param service
   * @returns
   */
  ValidateAllCheck = (editPanel: EditPanelElementModel, service: DevelopScriptServicePack) => {
    // メッセージをクリア
    service.messageService.clearMessage();
    editPanel.inputPartsList;
    let result = true;

    // 通常の入力項目
    if (!editPanel.checkValidateAllInputParts() || !this.validateTimeCheck(editPanel)) {
      service.messageService.addMessage('入力エラーがあります。', MessageType.Error);
      result = false;
    }

    // サブチケット
    editPanel.subTicketListPanelElementModel.subTicketList.forEach((subTicket: SubTicketBaseModel, index: number) => {
      if (!subTicket.ticketInfo.active) {
        return;
      }
      subTicket.subTicketColumns.forEach((subTicketColumn: any) => {
        if (subTicketColumn.isHidden || subTicketColumn.inputParts.disabled) {
          return;
        }
        if (!subTicketColumn.inputParts.checkValidate()) {
          service.messageService.addMessage(
            `発注リスト${index + 1}行目 ${subTicketColumn.inputParts.errMsg}`,
            MessageType.Error
          );
          result = false;
        }
      });
    });
    return result;
  };
}
